import api from './api';

const expenseCategoryMasterService = {
  getAllCategories: async (params = {}) => {
    try {
      const response = await api.get('/expense-category-master', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching all expense category master records:', error);
      throw error;
    }
  },

  getCategoryById: async (id) => {
    try {
      const response = await api.get(`/expense-category-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching expense category master record with ID ${id}:`, error);
      throw error;
    }
  },

  getNextCategoryCode: async () => {
    try {
      const response = await api.get('/expense-category-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next category code:', error);
      throw error;
    }
  },

  createCategory: async (categoryData) => {
    try {
      const response = await api.post('/expense-category-master', categoryData);
      return response.data;
    } catch (error) {
      console.error('Error creating expense category master record:', error);
      throw error;
    }
  },

  updateCategory: async (id, categoryData) => {
    try {
      const response = await api.put(`/expense-category-master/${id}`, categoryData);
      return response.data;
    } catch (error) {
      console.error(`Error updating expense category master record with ID ${id}:`, error);
      throw error;
    }
  },

  deleteCategory: async (id) => {
    try {
      const response = await api.delete(`/expense-category-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting expense category master record with ID ${id}:`, error);
      throw error;
    }
  },

  getCategoryStats: async () => {
    try {
      const response = await api.get('/expense-category-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching expense category master stats:', error);
      throw error;
    }
  },

  getActiveCategories: async () => {
    try {
      const response = await api.get('/expense-category-master/active');
      return response.data;
    } catch (error) {
      console.error('Error fetching active categories:', error);
      throw error;
    }
  },
};

export default expenseCategoryMasterService;

